import React from 'react';
import { connect } from 'react-redux';

import {
  setTextWidth,
  setVerticalPadding,
  setTextBgColor,
  setTextColor,
  setBorderColor,
  setButtonStyle,
  setButtonBgColor,
  setButtonTextIconColor,
  setButtonContent,
  setIconColor,
  setPlaceholderText,
} from '../actions/search-element-actions';

import styles from '../../../../stylesheet/css/header-builder/search-element-options.css';

export const SearchElementOptions = ({
  onTextWidthChange,
  onVerticalPaddingChange,
  onTextBgColorChange,
  onTextColorChange,
  onBorderColorChange,
  onButtonStyleChange,
  onButtonBgColorChange,
  onButtonTextIconColorChange,
  onButtonContentChange,
  onIconColorChange,
  onPlaceholderTextChange,
  options = {},
}) => {
  const {
    textWidth,
    verticalPadding,
    textBgColor,
    textColor,
    borderColor,
    buttonStyle,
    buttonBgColor,
    buttonTextIconColor,
    buttonContent,
    iconColor,
    placeholderText,
  } = options;

  const handleTextWidthChange = e => onTextWidthChange(e.target.value);
  const handleVerticalPaddingChange = e => onVerticalPaddingChange(e.target.value);
  const handleTextBgColorChange = e => onTextBgColorChange(e.target.value);
  const handleTextColorChange = e => onTextColorChange(e.target.value);
  const handleBorderColorChange = e => onBorderColorChange(e.target.value);
  const handleButtonStyleChange = e => onButtonStyleChange(e.target.value);
  const handleButtonBgColorChange = e => onButtonBgColorChange(e.target.value);
  const handleButtonTextIconColorChange = e => onButtonTextIconColorChange(e.target.value);
  const handleButtonContentChange = e => onButtonContentChange(e.target.value);
  const handleIconColorChange = e => onIconColorChange(e.target.value);
  const handlePlaceholderTextChange = e => onPlaceholderTextChange(e.target.value);

  const isButtonVisible = buttonStyle === 'button';
  const isIconVisible = buttonStyle === 'icon';

  return (
    <div>
      <header>Text Field Width:</header>
      <input type="text" value={textWidth} onChange={handleTextWidthChange} />

      <header>Vertical Padding:</header>
      <input type="text" value={verticalPadding} onChange={handleVerticalPaddingChange} />

      <header>Text Field BG Color:</header>
      <input type="color" value={textBgColor} onChange={handleTextBgColorChange} />

      <header>Text Color:</header>
      <input type="color" value={textColor} onChange={handleTextColorChange} />

      <header>Border Color:</header>
      <input type="color" value={borderColor} onChange={handleBorderColorChange} />

      <header>Button Style:</header>
      <select value={buttonStyle} onChange={handleButtonStyleChange}>
        <option value="button">Button</option>
        <option value="icon">Icon</option>
        <option value="none">None</option>
      </select>

      {isButtonVisible &&
        <header>Button BG Color:</header>
      }
      {isButtonVisible &&
        <input type="color" value={buttonBgColor} onChange={handleButtonBgColorChange} />
      }

      {isButtonVisible &&
        <header>Button Text/Icon Color:</header>
      }
      {isButtonVisible &&
        <input type="color" value={buttonTextIconColor} onChange={handleButtonTextIconColorChange} />
      }

      {isButtonVisible &&
        <header>Button Content:</header>
      }
      {isButtonVisible &&
        <select value={buttonContent} onChange={handleButtonContentChange}>
          <option value="icon">Icon</option>
          <option value="text">Text</option>
        </select>
      }

      {isIconVisible &&
        <header>Icon Color:</header>
      }
      {isIconVisible &&
        <input type="color" value={iconColor} onChange={handleIconColorChange} />
      }

      <header>Placeholder Text:</header>
      <input type="text" value={placeholderText} onChange={handlePlaceholderTextChange} />
    </div>
  );
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const { device, id } = ownProps;

  return {
    onTextWidthChange(value) {
      dispatch(setTextWidth({ device, id, value }));
    },

    onVerticalPaddingChange(value) {
      dispatch(setVerticalPadding({ device, id, value }));
    },

    onTextBgColorChange(value) {
      dispatch(setTextBgColor({ device, id, value }));
    },

    onTextColorChange(value) {
      dispatch(setTextColor({ device, id, value }));
    },

    onBorderColorChange(value) {
      dispatch(setBorderColor({ device, id, value }));
    },

    onButtonStyleChange(value) {
      dispatch(setButtonStyle({ device, id, value }));
    },

    onButtonBgColorChange(value) {
      dispatch(setButtonBgColor({ device, id, value }));
    },

    onButtonTextIconColorChange(value) {
      dispatch(setButtonTextIconColor({ device, id, value }));
    },

    onButtonContentChange(value) {
      dispatch(setButtonContent({ device, id, value }));
    },

    onIconColorChange(value) {
      dispatch(setIconColor({ device, id, value }));
    },

    onPlaceholderTextChange(value) {
      dispatch(setPlaceholderText({ device, id, value }));
    },
  };
};

export default connect(
  null,
  mapDispatchToProps
)(SearchElementOptions);



// WEBPACK FOOTER //
// ./app/header-builder/components/SearchElementOptions.js